
import { Component, OnInit, ViewChild, Input, ElementRef, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { configuration } from '../../../environments/config';
import { MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { first, forkJoin } from 'rxjs';
import { GetJsonObjectService } from '../../shared/services/get-json-object.service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DetailAppelASupport } from '../detail-appel-a-support/detail-appel-a-support';
import { MatIconModule } from '@angular/material/icon';
import { PrimeNgArrayD4Component } from '../../shared/prime-ng-array-d4/prime-ng-array-d4.component';
import { MaterialModule } from '../../material-module';
import { columnDefinition, twoLinesDisplay } from '../../shared/prime-ng-array-d4/prime-ng-array-d4.service';
import { environment } from '../../../environments/environment';
import { AjoutAppelASupportimplements } from '../ajout-appel-a-support/ajout-appel-a-support';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-liste-appel-a-support',
  standalone: true,
  imports: [CommonModule, MatSidenavModule, MatProgressSpinnerModule, DetailAppelASupport, AjoutAppelASupportimplements ,MatIconModule, PrimeNgArrayD4Component, MaterialModule],
  templateUrl: './liste-appel-a-support.html',
  styleUrl: './liste-appel-a-support.scss'
})
export class ListeAppelASupport implements OnInit {

  public societyList: any[] = [];
  public tickets: any[] = [];

  public appelASupportArray: any;
  public formControlArray: FormControl[] = [];
  public columnsToDisplay: string[] = [];
  public filterValues: any = [];
  public loading: boolean = true;
  public topGapSidenavRight: number = 0;
  public sideNavIsDisable: boolean = false;
  public backDropIsActivated: boolean = false;
  public displayAppappelASupport: boolean = false;
  public indiceAppelASupport: any;
  public employeesMap = new Map<string, Iemployees>();
  public scrollinInBottom: boolean = true;
  public enumState: { value: any; displayValue: string }[] = []// configuration.appelASupport.enumEtatAvancement;
  public asIdFromUrl: string | undefined = undefined;


  public columnsDefinition: columnDefinition[] = []


  @ViewChild('snav', { static: true }) public snav: any;
  @ViewChild('detailAS', { static: true }) detailAS: MatSidenavContent | undefined;

  @Input() asToOpen: string = "";
  @Input() listappelASupports: any;
  @Input() teamMember: any;
  selectedAppelASupport: any;

  constructor(private getJsonObjectService: GetJsonObjectService, private route: ActivatedRoute) {

    this.enumState =
      [
        { value: 0, displayValue: "En cours" },
        { value: 1, displayValue: "En cours" },
        { value: 2, displayValue: "En cours" },
        { value: 3, displayValue: "Validé, à cloturer" }
      ]

    this.columnsDefinition =
      [
        { displayName: "Appel à support", name: "clientReference", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
        { displayName: "Sujet", name: "subject", readOnly: true, ngStyle: { 'flex.px': '0 0 500' }, type: 'string', enum: null, drop: null, localFilter: true },
        { displayName: "Société", name: "companyName", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
        { displayName: "Etat", name: "statusLabel", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
        {
          displayName: "Temps consommé", name: "totalWork", readOnly: true, ngStyle: { 'flex.px': '0 0 140' }, type: 'duration', enum: null, drop: null, localFilter: true,
          printLine: {
            methodImplementation: (object) => {
              if (object?.totalWork != null) {
                let returnValue: twoLinesDisplay = {
                  topLine: '<span style="text-align: right">' + object.totalWork + " h" + '</span>',
                  bottomLine: ""
                }
                return returnValue
              }
              else {
                let returnValue: twoLinesDisplay = {
                  topLine: '<span style="text-align: right"> </span>',
                  bottomLine: ""
                }
                return returnValue
              }
            }
          },
        },
        { displayName: "Déposé le", name: "creationDateTimeUtc", readOnly: true, ngStyle: { 'flex.px': '0 0 200' }, type: 'dateTime', enum: null, drop: null, localFilter: true },
        { displayName: "Emetteur", name: "conversation[0].authorDisplayName", readOnly: true, ngStyle: { 'flex.px': '1 0 180' }, type: 'string', enum: null, drop: null, localFilter: true },
        // { displayName: "", name: "edit", readOnly: true, ngStyle: { 'flex.px': '1 0 42' }, type: 'edit', enum: null, drop: null, localFilter: false },
      ]
    
    if(this.route.snapshot.paramMap.get('idAs') != null)
      this.asIdFromUrl = this.route.snapshot.paramMap.get('idAs')!;
  }

  ngOnInit() {
    this.initialise();
  }

  private initialise() {
    this.topGapSidenavRight = 0;
    this.getDatas();


    console.log(this.enumState);
  }

  public refresh() { this.loading = true; this.getDatas(); }

  private getDatas() {
    this.employeesMap = new Map<string, Iemployees>();
    this.societyList = [];
    this.tickets = [];
    let getterObservable: any[] = [];
    getterObservable.push(this.getJsonObjectService.getJson("support/companies/my"));
    getterObservable.push(this.getJsonObjectService.getJson("support/tickets"));
    getterObservable.push(this.getJsonObjectService.getJson("support/team"));

    forkJoin(getterObservable).subscribe(async (getResults: any) => {
      let societyList = getResults[0];
      this.tickets = getResults[1];
      this.teamMember = getResults[2];
      if (Array.isArray(this.tickets)) {
        this.tickets.forEach((ticket: any) => {
          ticket["id"] = ticket.ticketUniqueId;
          ticket["statusLabel"] = this.enumState.find((state) => state.value == ticket.statusId)?.displayValue ?? "Clôturé";
        })
      }
      for (let i = 0; i < societyList.length; i++) {
        for (let j = 0; j < societyList[i]?.employees?.length; j++) {
          let employe: Iemployees =
          {
            "lastName": societyList[i].employees[j].lastName,
            "firstName": societyList[i].employees[j].firstName,
            "title": societyList[i].employees[j].title,
            "displayName": societyList[i].employees[j].displayName,
            "personUniqueid": societyList[i].employees[j].personUniqueid
          };
          this.employeesMap.set(societyList[i].employees[j].personUniqueId, employe);
        }
        this.societyList.push(societyList[i])
      }
      this.loading = false
      if (this.asIdFromUrl != undefined) {
        this.selectedAppelASupport = this.tickets.find(ticket => ticket.id === this.asIdFromUrl);
        if(this.selectedAppelASupport != null)
          this.displayappelASupport(this.selectedAppelASupport);
      }
    })
  }



  public asDetailHeight(componentHeight: number) {
    if (this.detailAS && this.detailAS.getElementRef().nativeElement.scrollHeight > this.detailAS.getElementRef().nativeElement.clientHeight)
      this.scrollinInBottom = false;
    else
      this.scrollinInBottom = true;
  }



  public setScrollToBottom() {
    if (this.detailAS) {
      this.detailAS.getElementRef().nativeElement.style.scrollBehavior = "smooth";
      this.detailAS.getElementRef().nativeElement.scrollTop = 65536;
    }
  }

  public lockSideNav() {
    this.sideNavIsDisable = true;
  }

  public unlockSideNav() {
    this.sideNavIsDisable = false;
  }

  public closeSideNav() {
    this.sideNavIsDisable = false;
    this.snav.close();
  }

  public displayappelASupport(row: any) {

    this.selectedAppelASupport = row;
    //find appelASupport usind row identifiant

    if (this.selectedAppelASupport != null) {
      this.displayAppappelASupport = true;
      if (!this.snav.opened) {
        this.snav.open();
      }
    }
  }

  public myScrollHandler(event: any) {
    if (event.target.scrollHeight < event.target.clientHeight)
      this.scrollinInBottom = true;
    else if (event.target.scrollHeight - event.target.clientHeight < (event.target.scrollTop + 25))
      this.scrollinInBottom = true;
    else
      this.scrollinInBottom = false;
  }
}

export interface Iemployees {
  firstName: string,
  lastName: string,
  title: string,
  displayName: string,
  personUniqueid: string;
}
